import { Text } from 'preact-i18n';

const NoRecentValueBadge = () => (
  <span class="badge bg-warning">
    <Text id="dashboard.boxes.devicesInRoom.noRecentValue" />
  </span>
);

export default NoRecentValueBadge;
